import { NgModule } from '@angular/core';
import { ControlRequiredPipe } from './controlRequiredPipe';

@NgModule({
	declarations: [ControlRequiredPipe],
	imports: [],
	exports: [ControlRequiredPipe],
	providers: [],
})
export class ControlRequiredPipeModule {}
